import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Constellation Components
import {
    FormField,
    Input,
    Label,
    Spacer,
} from '@zillow/constellation';

// Styled Components
import {
    StyledActionsContainerSpacer,
    StyledIconCloseOutline,
    StyledIconReload,
    StyledImgInfoDiv,
    StyledText,
    StyledUploadedImgDiv,
} from './StyledComponents';

const propTypes = {
    photo: PropTypes.object.isRequired,
    hideCaption: PropTypes.bool,
    onBlur: PropTypes.func.isRequired,
    initialValue: PropTypes.string,
    rotatePhoto: PropTypes.func.isRequired,
    removePhoto: PropTypes.func.isRequired,
};

const defaultProps = {
    hideCaption: false,
    initialValue: '',
};

const PhotoDisplay = ({
    photo,
    hideCaption,
    onBlur,
    initialValue,
    rotatePhoto,
    removePhoto,
}) => {
    const [captionText, setCaptionText] = useState(initialValue);
    const [prevText, setPrevText] = useState(initialValue);

    const handleOnChange = (event) => {
        setCaptionText(event.target.value);
    };

    const handleSubmit = (event) => {
        onBlur(event);
        setPrevText(captionText);
    };

    const handleKeyUp = (event) => {
        if (event.key === 'Enter') handleSubmit(event);
    };

    const handleOnBlur = (event) => {
        if (prevText !== captionText) handleSubmit(event);
    };

    if (photo.url) {
        photo.url = photo.url.replace('http://photo', 'https://photonet');
    }

    return (
        <Spacer paddingY="sm" className="PhotoDisplay">
            <StyledUploadedImgDiv>
                <img alt="carousel-img" src={photo.url ? photo.url : photo.preview} />
            </StyledUploadedImgDiv>
            <StyledImgInfoDiv>
                {!hideCaption ? (
                    <Spacer paddingY="xs">
                        <FormField>
                            <Label>Caption</Label>
                            <Input
                                onBlur={handleOnBlur}
                                onChange={handleOnChange}
                                onKeyUp={handleKeyUp}
                                name="caption"
                                placeholder="Describe this photo"
                                value={captionText}
                                data-test="photo-display-caption"
                            />
                        </FormField>

                        <StyledActionsContainerSpacer marginTop="xs">
                            <div onClick={rotatePhoto}>
                                <StyledText>
                                    <StyledIconReload />
                                    Rotate photo
                                </StyledText>
                            </div>

                            <div onClick={removePhoto}>
                                <StyledText>
                                    <StyledIconCloseOutline />
                                    Delete photo
                                </StyledText>
                            </div>
                        </StyledActionsContainerSpacer>
                    </Spacer>
                ) : null}
            </StyledImgInfoDiv>
        </Spacer>
    );
};

PhotoDisplay.propTypes = propTypes;
PhotoDisplay.defaultProps = defaultProps;

export { PhotoDisplay };
export default PhotoDisplay;
